import React from 'react';

import ProcoreLogo from 'icons/procore_logo.svg';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import BreadCrumbList from 'components/application/BreadCrumbList';
import SearchField from 'components/application/SearchField';

export function Content({
  breadCrumbOptions,
  hasNoSearchResults,
  isSearchable,
  onSearchQueryChange,
  onSearchQueryReset,
  onTraversalReset,
  resourceCount,
  searchPlaceholder,
  searchQuery,
  selectionOptions,
}) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'procore.fileDestination.components.modal.Selection',
  });

  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  return (
    <>
      <div className='tw-px-8 tw-py-4'>
        <div className='tw-flex'>
          <h4 className='tw-mb-1 tw-mt-0 tw-text-xl tw-font-semibold tw-tracking-tight tw-text-grey-900'>
            {i18nT('title')}
          </h4>
        </div>
        <p className='tw-mb-0'>{i18nT('description')}</p>
      </div>
      <hr className='tw-m-0 tw-h-px tw-border-0 tw-bg-grey-100' />
      <div className='tw-p-8'>
        <div className='tw-my-4'>
          <BreadCrumbList
            breadCrumbOptions={breadCrumbOptions}
            leadingIcon={
              <ProcoreLogo
                className='tw-mr-2 tw-shrink-0 tw-cursor-pointer'
                height='12px'
                onClick={onTraversalReset}
                width='12px'
              />
            }
          />
        </div>
        {isSearchable && (
          <SearchField
            additionalClasses='tw-w-full tw-mb-2'
            name='procoreSelectionSearch'
            onChange={onSearchQueryChange}
            onReset={onSearchQueryReset}
            placeholder={searchPlaceholder}
            value={searchQuery}
          />
        )}
        {resourceCount && (
          <div className='tw-mb-2 tw-mt-4 tw-text-s tw-font-medium tw-text-grey-700'>
            {resourceCount}
          </div>
        )}
        <div className='tw-h-61 tw-overflow-auto tw-border-1 tw-border-solid tw-border-grey-100 tw-bg-grey-025'>
          {hasNoSearchResults ?
            <div className='tw-flex tw-h-full tw-items-center tw-justify-center tw-text-s tw-text-grey-500'>
              {i18nTShared('noMatchingResults')}
            </div>
          : selectionOptions}
        </div>
      </div>
    </>
  );
}

Content.propTypes = {
  breadCrumbOptions: PropTypes.array.isRequired,
  hasNoSearchResults: PropTypes.bool,
  isSearchable: PropTypes.bool,
  onSearchQueryChange: PropTypes.func.isRequired,
  onSearchQueryReset: PropTypes.func.isRequired,
  onTraversalReset: PropTypes.func.isRequired,
  resourceCount: PropTypes.node,
  searchPlaceholder: PropTypes.string,
  searchQuery: PropTypes.string.isRequired,
  selectionOptions: PropTypes.node.isRequired,
};
